import { v4 as uuidv4 } from 'uuid';
import { DUMMY_RESTAURANT_CODE } from '../constants';
import { AgentTypes, EventTypes } from '../constants/event';
import { UserDetails } from '../types';
import { post } from './api';
import { infoSeqIdCounter } from '../app/middleware';
import {
  InfoTransmissionMessage,
  messagingActions,
} from '../reducers/messagingSlice';

interface SendAsrIncorrectEventParams {
  eventAPI: string | null;
  eventAPIAuth: string | null;
  restaurantCode: string | null;
  effectiveSessionId: string | null;
  userDetails: UserDetails | null;
  wordClicked: string;
  dispatch: Function;
}

export const sendAsrIncorrectEvent = ({
  eventAPI,
  eventAPIAuth,
  restaurantCode,
  effectiveSessionId,
  userDetails,
  wordClicked,
  dispatch,
}: SendAsrIncorrectEventParams) => {
  if (!eventAPI || !eventAPIAuth) {
    return;
  }

  const { id, username, email, firstName, lastName } =
    userDetails || ({} as UserDetails);

  const payload = {
    id: uuidv4(),
    seq: infoSeqIdCounter.increment(),
    agent_id: id || username || 'unknown_agent',
    agent_type: AgentTypes.HITL,
    session_id: effectiveSessionId || 'dummy_session_id',
    timestamp: new Date().toISOString(),
    event: EventTypes.asrIncorrect,
    data: {
      word_clicked: wordClicked,
      session_id: effectiveSessionId || 'dummy_session_id',
    },
    restaurant_code: restaurantCode || DUMMY_RESTAURANT_CODE,
    metadata: {
      agent_name: username,
      agent_email: email,
      agent_first_name: firstName,
      agent_last_name: lastName,
    },
  };

  post({
    url: `${eventAPI}/v1/event`,
    data: payload,
    headers: {
      Authorization: `Basic ${eventAPIAuth}`,
    },
  });

  const infoPayload: Partial<InfoTransmissionMessage> = {
    data: {
      message: 'Incorrect / Missing ASR',
      type: 'METRIC',
      code: EventTypes.asrIncorrect,
      metadata: {
        word_clicked: wordClicked,
      },
    },
  };
  dispatch(messagingActions.sendInfo(infoPayload as any));
};
